module.exports = __webpack_public_path__ + "img/2.507f7767.jpg";